const CHAT_MESSAGES_AMOUNT = 20

const InitMsg = (firstName: string, secondName: string) => ({
  author: {
    isAdmin: '1',
  },
  _id: '1',
  text: `Здравствуйте, ${firstName} ${secondName}! Рады, что Вы с нами! 🙂`,
  isNoReply: true,
})

const SystemQuestionMsg = {
  author: {
    isAdmin: '1',
  },
  _id: '1',
  text: 'Коллеги, задавайте ваши вопросы для обсуждения в конце вебинара! 🙂',
  isNoReply: true,
}

const initCheckup = { checkupId: 0, successCheckup: false }

const InitMsgStatus = {
  INIT: 'INIT',
  SET: 'SET',
  UNSET: 'UNSET',
}

export { CHAT_MESSAGES_AMOUNT, InitMsg, SystemQuestionMsg, initCheckup, InitMsgStatus }
